<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-select id="tmc-import-fee-select"
          class="tmc-import fee"
          :items="taxFeeMasterData"
          :item-text="feeItemText"
          item-value="feeNumber"
          :label="input.label || 'Fee'"
          :value="input.value"
          :rules="required"
          @change="emitInput('value', $event)"
        ></v-select>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

import {
  mapActions,
  mapState,
} from 'vuex';

export default {
  name: 'TaxFeeMasterInput',
  props: {
    input: {
      type: Object,
      default: () => ({}),
    },
  },
  created() {
    this.loadFeeMasterTypes();
  },
  computed: {
    ...mapState({
      taxFeeMasterData: (state) => state.shared.taxFeeMaster.taxFeeMasterData || [],
    }),
    required() {
      // fee number 0 is a valid selection, so an empty check cannot use !!value
      return [
        (value) => (value !== null && value !== undefined && value !== '') || 'Required',
      ];
    },
  },
  methods: {
    ...mapActions('shared/taxFeeMaster', [
      'loadTaxFeeMasterTypes',
    ]),
    async loadFeeMasterTypes() {
      // no baseCrudKey on purpose: writing a new key into base/crud items would
      // recompute the profile list behind the 'Type of import' select and clear it
      await this.loadTaxFeeMasterTypes({
        criteria: { sortBy: [{ column: 'feeNumber', direction: 'asc' }] },
      });
    },
    feeItemText(item) {
      return `${item.feeNumber} - ${item.feeDescription}`;
    },
    async emitInput(type, value) {
      this.$emit('input', {
        type,
        value,
      });
    },
  },
};

</script>
